import PropTypes from 'prop-types'
import React from 'react'
import styled, { css } from 'styled-components'
import { find } from 'lodash'
import Question from 'components/question'
import VideoResponse from 'components/video-response/video-response'
import { CardGroup, CardContainer } from 'components/styled/card-group'
import { Box } from 'components/styled/containers/box'

const propTypes = {
  questions: PropTypes.arrayOf(PropTypes.shape({})),
  responses: PropTypes.arrayOf(PropTypes.shape({})),
  showResponses: PropTypes.bool,
  context: PropTypes.oneOf([
    'application',
    'candidate',
    'messages',
    'admin',
    'embedded',
  ]),
  onVideoSubmit: PropTypes.func,
  onVideoChange: PropTypes.func,
  onVideoRemove: PropTypes.func,
  useFileUpload: PropTypes.bool,
  uuid: PropTypes.string,
  type: PropTypes.string,
  onHeightChange: PropTypes.func,
  enableSubmit: PropTypes.bool,
  videoEventProps: PropTypes.shape({}),
  locationId: PropTypes.string,
  allowUploadWithRecord: PropTypes.bool,
  disableResponse: PropTypes.bool,
  isEmbedded: PropTypes.bool,
  createDraftCandidate: PropTypes.func,
}

const defaultProps = {
  questions: undefined,
  responses: [],
  showResponses: true,
  context: undefined,
  useFileUpload: false,
  uuid: undefined,
  type: undefined,
  onVideoSubmit: undefined,
  onVideoChange: undefined,
  onVideoRemove: undefined,
  onHeightChange: undefined,
  enableSubmit: true,
  videoEventProps: undefined,
  locationId: undefined,
  allowUploadWithRecord: false,
  disableResponse: false,
  isEmbedded: false,
  createDraftCandidate: undefined,
}

const VideoContainer = styled(Box)`
  height: 100%;
`
const StyledCardGroupWrapper = styled.div`
  margin: 0 auto;
  max-width: ${({ isEmbedded }) => (isEmbedded ? '665px' : '100%')};
  ${({ theme }) => theme.mediaQuery.screenS} {
    margin-bottom: ${({ theme, isEmbedded }) =>
      isEmbedded ? theme.space.s0 : theme.space.s20};
  }

  ${({ theme }) => theme.mediaQuery.smallTablet} {
    max-width: ${({ isEmbedded }) => (isEmbedded ? '300px' : '100%')};
    margin-bottom: ${({ theme, isEmbedded }) => isEmbedded && theme.space.s8};
  }

  &:first-of-type {
    ${CardContainer} {
      padding-top: 0;
    }
  }
`

function QuestionResponseDialogue({
  context = 'candidate',
  useFileUpload,
  onHeightChange,
  onVideoSubmit,
  onVideoChange,
  onVideoRemove,
  questions,
  responses,
  showResponses,
  uuid,
  type,
  enableSubmit,
  videoEventProps,
  locationId,
  allowUploadWithRecord,
  isEmbedded,
  createDraftCandidate,
  disableResponse,
}) {
  return (
    <div className="question-response-dialogue">
      {questions &&
        questions.map(question => (
          <StyledCardGroupWrapper isEmbedded={isEmbedded} key={question._id}>
            <CardGroup minWidth="s320" key={question._id}>
              <VideoContainer>
                <Question
                  question={question}
                  className="radius"
                  locationId={locationId}
                  videoEventProps={videoEventProps}
                />
              </VideoContainer>
              <VideoContainer>
                {showResponses && question.answerable ? (
                  <VideoResponse
                    className={`count-${questions.length}`}
                    question={question}
                    useFileUpload={useFileUpload}
                    disableRecording={disableResponse}
                    uuid={uuid}
                    type={type}
                    response={find(responses, { questionId: question._id })}
                    context={context}
                    onHeightChange={onHeightChange}
                    createDraftCandidate={createDraftCandidate}
                    onVideoSubmit={
                      enableSubmit && onVideoSubmit
                        ? () => onVideoSubmit(question._id)
                        : undefined
                    }
                    onVideoChange={() => {
                      onVideoChange && onVideoChange(question._id)
                    }}
                    onVideoRemove={() => {
                      onVideoRemove && onVideoRemove(question._id)
                    }}
                    videoEventProps={videoEventProps}
                    locationId={locationId}
                    allowUploadWithRecord={allowUploadWithRecord}
                    isEmbedded={isEmbedded}
                  />
                ) : null}
              </VideoContainer>
            </CardGroup>
          </StyledCardGroupWrapper>
        ))}
    </div>
  )
}

QuestionResponseDialogue.propTypes = propTypes
QuestionResponseDialogue.defaultProps = defaultProps

export default QuestionResponseDialogue
